import { Component, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { AppRoutes } from '@shared/const/app.routes';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu',
  imports: [MatExpansionModule, MatSidenavModule, MatListModule, RouterOutlet, CommonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css',
})
export class MenuComponent {
  private _router = inject(Router);

  routes = AppRoutes;

  readonly panelOpenStateSearch = signal(false);
  readonly panelOpenStateConfiguration = signal(false);
  readonly panelOpenStateBooking = signal(false);

  // estado del menú
  isExpanded = signal<boolean>(false);

  toggleDrawer(): void {
    this.isExpanded.update(v => !v);
    if (!this.isExpanded()) this.closeExpansionPanels();
  }
  onHeaderClick(): void {
    if (this.isExpanded()) return;
    this.isExpanded.set(true);
    this.closeExpansionPanels();
  }

  closeExpansionPanels() {
    this.panelOpenStateSearch.set(false);
    this.panelOpenStateConfiguration.set(false);
    this.panelOpenStateBooking.set(false);
  }

  goTo(url: string) {
    this.closeExpansionPanels();
    this.isExpanded.set(false);
    this._router.navigateByUrl(url);
  }
}
